import ContainerComponent from './Container/Container'
import ContentComponent from './Content/Content'
import HeaderComponent from './Header/Header'
import NavigationComponent from './Navigation/Navigation'
import SidebarComponent from './Sidebar/Sidebar'
import TopBarComponent from './TopBar/TopBar'

export const LayoutContainer = ContainerComponent
export const LayoutContent = ContentComponent
export const LayoutHeader = HeaderComponent
export const LayoutNavigation = NavigationComponent
export const LayoutSidebar = SidebarComponent
export const LayoutTopBar = TopBarComponent
